"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var AgencyMixin = /** @class */ (function () {
    function AgencyMixin() {
    }
    /**
     * Get agencies.
     * @param query
     * @param callback
     */
    AgencyMixin.prototype.getAgencies = function (query, callback) {
        var _this = this;
        var urlParams = { query: query };
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.ShortAgency.parse, 'warn'));
        };
        this.http.get('/agencies', urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.getAgency = function (id, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.LongAgency.parse));
        };
        this.http.get("/agencies/" + id, null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.linkFreshdeskCompany = function (agencyId, freshdeskCompanyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + agencyId + "/freshdesk-link", null, {
            freshdeskCompanyId: freshdeskCompanyId,
        }, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.getAgencyFeatures = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AgencyFeatures.parse));
        };
        this.http.get("/agencies/" + agencyId + "/features", null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.editAgencyFeatures = function (agencyId, haEnabled, stationBoardFeatureStatus, callback) {
        var _this = this;
        var stationBoardEnabled = null;
        var stationBoardExpirationValue = null;
        if (stationBoardFeatureStatus != null) {
            stationBoardEnabled = stationBoardFeatureStatus.type != 'disabled';
            if (stationBoardFeatureStatus.type == 'enabled') {
                stationBoardExpirationValue = stationBoardFeatureStatus.expiration != null ? Math.floor(stationBoardFeatureStatus.expiration.getTime() / 1000) : -1;
            }
        }
        var body = {
            haEnabled: haEnabled,
            stationBoardExpiration: stationBoardExpirationValue,
            stationBoardEnabled: stationBoardEnabled,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/features", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.createAgency = function (agencyKey, boundary, latitude, longitude, country, county, name, showHydrants, state, town, timezone, usfaId, signupId, stripeCustomerId, callback) {
        var _this = this;
        var body = {
            agencyKey: agencyKey,
            boundary: boundary,
            latitude: latitude,
            longitude: longitude,
            country: country,
            county: county,
            name: name,
            showHydrants: showHydrants,
            state: state,
            town: town,
            timezone: timezone,
            usfaId: usfaId,
            signupId: signupId,
            stripeCustomerId: stripeCustomerId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.ShortAgency.parse));
        };
        this.http.post('/agencies', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.transferAgency = function (agencyId, deployment, callback) {
        var _this = this;
        var body = { deployment: models_1.Deployment[deployment] };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + agencyId + "/transfer", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.editAgency = function (agencyId, editBody, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId, null, editBody, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.splitAgency = function (originalAgencyId, agencyKey, boundary, latitude, longitude, country, county, name, showHydrants, state, town, timezone, moveUnitIds, moveStationIds, callback) {
        var _this = this;
        var body = {
            newAgency: {
                agencyKey: agencyKey,
                boundary: boundary,
                latitude: latitude,
                longitude: longitude,
                country: country,
                county: county,
                name: name,
                showHydrants: showHydrants,
                state: state,
                town: town,
                timezone: timezone,
            },
            unitIds: moveUnitIds,
            stationIds: moveStationIds,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + originalAgencyId + "/split", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.getAgencyClients = function (id, limit, page, query, manager, types, callback) {
        var _this = this;
        var body = {
            limit: limit,
            page: page,
        };
        if (query != null) {
            body.search = query;
        }
        if (manager != null) {
            body.manager = manager;
        }
        if (types != null) {
            body.types = types.map(function (t) { return models_1.Bryx911ClientType[t]; }).join('+');
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AgencyClientCount.parse));
        };
        this.http.get("/agencies/" + id + "/clients", body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.getAgencyGroups = function (id, type, callback) {
        var _this = this;
        var urlParams = (type != null ? {
            type: models_1.AgencyGroupTypeEnum[type],
        } : null);
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.AgencyGroup.parse, 'warn'));
        };
        this.http.get("/agencies/" + id + "/groups", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.editGroup = function (id, name, emailDsts, callback) {
        var _this = this;
        var body = {
            name: models_1.FieldUtils.getEditableParam(name),
            emailDsts: models_1.FieldUtils.getEditableParam(emailDsts),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/groups/" + id, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.getAgencySCUs = function (id, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.SearchSCU.parse, 'warn'));
        };
        this.http.get("/agencies/" + id + "/scus", null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.addStream = function (agencyId, streamId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        var body = { streamId: streamId };
        this.http.post("/agencies/" + agencyId + "/streams", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.removeStream = function (agencyId, streamId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/streams/" + streamId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.createStation = function (agencyId, name, addr, latitude, longitude, callback) {
        var _this = this;
        var body = {
            name: name,
            address: addr,
            latitude: latitude,
            longitude: longitude,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Station.parse));
        };
        this.http.post("/agencies/" + agencyId + "/stations", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.removeStation = function (agencyId, stationId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/stations/" + stationId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.getUnitJobs = function (id, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.UnitJob.parse, 'warn'));
        };
        this.http.get("/units/" + id + "/jobs", null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.createUnits = function (agencyId, params, callback) {
        var _this = this;
        var body = {
            units: params.map(function (p) { return ({
                unitKey: p.unitKey,
                name: p.name,
                parser: p.parser,
                alertEmails: p.alertEmails,
            }); }),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + agencyId + "/units", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.editUnitInfo = function (unitId, name, parser, alertEmails, cadDept, showOnSignup, callback) {
        var _this = this;
        var body = {
            name: name,
            parser: parser,
            alertEmails: alertEmails,
            cadDept: cadDept,
            showOnSignup: showOnSignup,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/units/" + unitId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.deleteUnit = function (unitId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/units/" + unitId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.addUnitEmailForward = function (unitId, forward, callback) {
        var _this = this;
        var body = { forward: forward };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/units/" + unitId + "/email-forwards", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.deleteUnitEmailForward = function (unitId, forward, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/units/" + unitId + "/email-forwards/" + forward, null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.addGroupToUnit = function (unitId, groupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        var body = {
            groupId: groupId,
        };
        this.http.post("/units/" + unitId + "/groups", null, body, wrappedCallback);
    };
    AgencyMixin.prototype.removeGroupFromUnit = function (unitId, groupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/units/" + unitId + "/groups/" + groupId, null, wrappedCallback);
    };
    AgencyMixin.prototype.uploadAgencyFile = function (agencyId, file, callback) {
        var _this = this;
        // TODO: This should be included in bryx-../../spoonClient but it does not support file upload currently
        var formData = new FormData();
        formData.append('file', file);
        var request = new XMLHttpRequest();
        request.onreadystatechange = function () {
            if (request.readyState == request.DONE) {
                if (request.status == 200) {
                    try {
                        callback(_this.apiSuccess(JSON.parse(request.responseText)['id']));
                    }
                    catch (_a) {
                        callback(_this.apiFailure('Invalid response'));
                    }
                }
                else {
                    callback(_this.apiFailure("Invalid response (" + request.status + "): " + request.responseText));
                }
            }
        };
        request.open('POST', this.apiRoot + "/agencies/" + agencyId + "/files");
        var apiKey = this.local.apiKey;
        if (apiKey != null) {
            request.setRequestHeader('X-API-KEY', apiKey);
        }
        request.send(formData);
    };
    AgencyMixin.prototype.getRaws = function (unitIds, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.DataEntry.parse, 'warn'));
        };
        this.http.get('/raws', { unitIds: unitIds.join('+') }, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.getRaw = function (rawId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.DataEntry.parse));
        };
        this.http.get("/raws/" + rawId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.getAgencyTranslations = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AgencyTranslations.parse));
        };
        this.http.get("/agencies/" + agencyId + "/translations", null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.addAgencyTranslation = function (agencyId, type, pattern, replaceWith, callback) {
        var _this = this;
        var body = {
            pattern: pattern,
            replaceWith: replaceWith,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AgencyTranslation.parse));
        };
        this.http.post("/agencies/" + agencyId + "/translations/" + type, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.editAgencyTranslation = function (agencyId, type, translationId, pattern, replaceWith, callback) {
        var _this = this;
        var body = {
            pattern: pattern,
            replaceWith: replaceWith,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AgencyTranslation.parse));
        };
        this.http.put("/agencies/" + agencyId + "/translations/" + type + "/" + translationId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.removeAgencyTranslation = function (agencyId, type, translationId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/translations/" + type + "/" + translationId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.pushAllScuConfigs = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + agencyId + "/scus/push-config", null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return AgencyMixin;
}());
exports.default = AgencyMixin;
//# sourceMappingURL=AgencyMixin.js.map